/**
 * @fileoverview パスワードリセットメール送信確認画面
 *
 * このファイルでは、パスワードリセットリクエストが送信された後に
 * ユーザーに表示される確認画面を定義しています。メールが送信されたことと、
 * 次のステップの案内を表示します。
 */

/**
 * パスワードリセットメール送信確認画面コンポーネント
 *
 * パスワードリセットメールが正常に送信されたことをユーザーに通知し、
 * メール内のリンクをクリックして次のステップに進むよう案内します。
 * メールアドレスの表示やリクエストの再送信オプションなども含みます。
 *
 * @returns {JSX.Element} パスワードリセットメール送信確認画面
 */
import { Stack, Text } from "@mantine/core";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";

export default function ResetPasswordEmailConfirmPage() {
  const navigate = useNavigate();

  return (
    <Card title="パスワードリセット">
      <Stack className="gap-10">
        <Text>
          ご入力いただいたメールアドレスに、パスワードリセット用のURLをお送りしました。
          URLにアクセスし、手順に従ってパスワードの再設定を行なってください。
        </Text>
        <div className="flex justify-end">
          <Button text="トップページへ戻る" onClick={() => navigate("/")} />
        </div>
      </Stack>
    </Card>
  );
}
